<mat-accordion *hasPermissionToModule="moduleNames.EducationHistory">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h2>{{ 'EducationHistoryDocuments' | translate }}</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @if (!readonly) {
      <div class="document-buttons">
        <span [matTooltipDisabled]="canAddEducationDocument" [matTooltip]="'AddEducationHistoryFileInformation' | translate">
          <button
            id="documents-section-add-eduction-document-button"
            mat-raised-button
            color="primary"
            [disabled]="!canAddEducationDocument"
            (click)="openModal()"
          >
            {{ 'WL-AddDocument' | translate }}
          </button>
        </span>
      </div>
    }
    <div class="table-wrapper">
      <table class="five-cols">
        <thead>
          <tr>
            <th class="column-fullname">{{ 'School' | translate }}</th>
            <th class="column-filename">{{ 'Name' | translate }}</th>
            <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
            <th class="column-isattached">{{ 'Status' | translate }}</th>
            <th class="column-actions">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (file of filesWithDocuments$ | async; track file) {
            <tr>
              <td class="column-fullname">{{ file?.School }}</td>
              <td class="column-filename">
                @for (f of file.Files; track f) {
                  <div>
                    <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name)">{{ f.Name }}</a>
                    @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Pending) {
                      <mat-icon
                        class="verification-badge verification-badge--pending"
                        [matTooltip]="'WorkerFilePendingVerificationTooltip' | translate"
                        >schedule</mat-icon
                      >
                    }
                    @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Rejected) {
                      <mat-icon
                        class="verification-badge verification-badge--rejected"
                        [matTooltip]="f.RejectionReason ?? ('WorkerFileRejectedTooltip' | translate)"
                        >cancel</mat-icon
                      >
                    }
                  </div>
                }
              </td>
              <td class="column-date">
                @for (f of file.Files; track f) {
                  <div>{{ f?.CreatedOn | date: 'yyyy-MM-dd' }}</div>
                }
              </td>
              <td class="column-isattached">
                @if (!file.Files) {
                  <span><mat-icon>error</mat-icon></span>
                }
                @if (!!file.Files) {
                  <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (f of file.Files; track f) {
                  <div>
                    <button
                      id="documents-section-download-education-document-button"
                      mat-icon-button
                      color="primary"
                      (click)="downloadFile(f.Id, f.Name)"
                    >
                      <mat-icon>download</mat-icon>
                    </button>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>
